/**
 * Authentication Middleware (Targeted)
 * Protects routes that require authentication
 * Apply to specific routes via: definePageMeta({ middleware: ['auth'] })
 */
export default defineNuxtRouteMiddleware(async to => {
  // For routes with ssr: false, skip server-side auth checks
  // The auth will be checked client-side after hydration
  if (import.meta.server && to.meta.ssr === false) {
    return
  }

  // On server, use Supabase's server-side session check
  if (import.meta.server) {
    const supabase = useSupabaseClient()
    const { data: { user } } = await supabase.auth.getUser()

    if (!user) {
      return navigateTo({
        name: 'auth-login',
        query: {
          ...to.query,
          to: to.fullPath !== '/' ? to.path : undefined,
        },
      })
    }

    return
  }

  // Client-side check
  const authStore = useAuthStore()

  // Wait for auth initialization
  if (!authStore.initialized)
    return

  // If not authenticated, redirect to login with return path
  if (!authStore.isAuthenticated) {
    return navigateTo({
      name: 'auth-login',
      query: {
        ...to.query,
        to: to.fullPath !== '/' ? to.path : undefined,
      },
    })
  }
})
